import React from 'react';
import PropTypes from 'prop-types';
import TriggerOrderVerificationModal from './TriggerOrderVerificationModal';
import ReadOnlyAccessModal from '../PriceAlerts/ReadOnlyAccessModal';
import PrimaryAccountHolderOnlyModal from '../PriceAlerts/PrimaryAccountHolderOnlyModal';

// Renders the correct block modal for the current Buy-at-Target-Price gate
// reason:
//   readOnly     -> Read Only Access modal        (74319)
//   primaryOnly  -> Primary Account Holder Only    (74317, Full Access)
//   deliveryOnly / pending -> account-verification modal (71992)
const TriggerOrderBlockModal = ({ variant, close }) => {
  if (variant === 'readOnly') {
    return <ReadOnlyAccessModal open onClose={close} openAtTop />;
  }

  if (variant === 'primaryOnly') {
    return <PrimaryAccountHolderOnlyModal open onClose={close} openAtTop />;
  }

  return (
    <TriggerOrderVerificationModal
      isOpen={!!variant}
      variant={variant}
      close={close}
    />
  );
};

TriggerOrderBlockModal.propTypes = {
  variant: PropTypes.oneOf([
    'deliveryOnly',
    'pending',
    'readOnly',
    'primaryOnly',
  ]),
  close: PropTypes.func,
};

export default TriggerOrderBlockModal;
